export default __webpack_public_path__ + "static/media/outlook.f6094f15.svg";